import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageUploadPopup from './PageUploadPopup';

function ViewUplodDocsSec({ inputData, uploadCb, removeCb }) {
  const [openPageUploadPopup, setOpenPageUploadPopup] = useState(false);
  const [parentId, setParentId] = useState(0);
  const handleAddPage = (paremtId) => {
    setOpenPageUploadPopup(true);
    setParentId(paremtId);
  };
  const handleRemoveFile = (fileNum, isParent) => {
    removeCb(fileNum, isParent);
  };

  return (
    <div>
      {inputData &&
        inputData.map((data, i) => (
          <div key={i} style={{ border: '1px solid #ccc' }}>
            <div className="insu-act-sec-bdy-rw flex-sec clear-top10 clear-left20">
              {/* <span className="nsu-act-lbl">&nbsp;</span> */}
              <span
                className="nsu-act-val"
                style={{
                  borderBottom: '1px dotted #dadada',
                  paddingBottom: '10px',
                }}
              >
                <a
                  href={data?.filePath}
                  style={{
                    margin: '5px 0px 0px 0px',
                  }}
                  target="_blank"
                  rel="noreferrer"
                >
                  {data.fileName}
                </a>
                <span
                  className="bold red clear-left10"
                  onClick={() => handleRemoveFile(data?.fileNum, true)}
                >
                  [X]
                </span>

                {data?.parentId === 0 && (
                  <>
                    <span className="red clear-left10"> | </span>
                    <Link className="bold clear-left10">
                      <span onClick={() => handleAddPage(data?.fileNum)}>
                        [Add more pages]
                      </span>
                    </Link>
                  </>
                )}

                <br />
                <span
                  className=""
                  style={{
                    margin: '5px 0px 0px 0px',
                    display: 'inline-block',
                  }}
                >
                  <span className="sec-colr">
                    SHA-256 HASH: {data?.encrtption}
                  </span>
                </span>
              </span>
            </div>
            {data?.pages &&
              data?.pages.map((pagedata, i) => (
                <div
                  key={i}
                  className="insu-act-sec-bdy-rw flex-sec clear-top10 clear-left20"
                >
                  {/* <span className="nsu-act-lbl">&nbsp;</span> */}
                  <span
                    className="nsu-act-val"
                    style={{
                      borderBottom: '1px dotted #dadada',
                      paddingBottom: '10px',
                    }}
                  >
                    <a
                      href={pagedata?.filePath}
                      style={{
                        margin: '5px 0px 0px 0px',
                      }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {pagedata.fileName}
                    </a>
                    <span
                      className="bold red clear-left10"
                      onClick={() => handleRemoveFile(pagedata?.fileNum, false)}
                    >
                      [X]
                    </span>

                    {pagedata?.parentId === 0 && (
                      <>
                        <span className="red clear-left10"> | </span>
                        <Link className="bold clear-left10">
                          <span
                            onClick={() => handleAddPage(pagedata?.fileNum)}
                          >
                            [Add more pages]
                          </span>
                        </Link>
                      </>
                    )}

                    <br />
                    <span
                      className=""
                      style={{
                        margin: '5px 0px 0px 0px',
                        display: 'inline-block',
                      }}
                    >
                      <span className="sec-colr">
                        SHA-256 HASH: {data?.encrtption}
                      </span>
                    </span>
                  </span>
                </div>
              ))}
          </div>
        ))}
      {openPageUploadPopup && (
        <PageUploadPopup
          uploadCb={uploadCb}
          handleClose={() => setOpenPageUploadPopup(false)}
          parentId={parentId}
        />
      )}
    </div>
  );
}

export default ViewUplodDocsSec;
